import { FaStar } from 'react-icons/fa';
import React from 'react';

export const HotTourRating = ({ hotelstars }) => {
  const stars = Array.from({ length: Number(hotelstars) }, (_, i) => (
    <FaStar key={i} />
  ));

  return stars;
};
